import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React__default, { useRef, useEffect } from 'react';
import StyledTableHeaderRow from './StyledTableHeaderRow.js';

const TableHeaderRow = React__default.memo((_a) => {
    var { scrollbarWidth, rtl, scrollLeft } = _a, rest = __rest(_a, ["scrollbarWidth", "rtl", "scrollLeft"]);
    const scrollerRef = useRef();
    useEffect(() => {
        var _a, _b;
        if ((_a = scrollerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo) {
            (_b = scrollerRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo({ left: scrollLeft });
        }
    }, [scrollLeft]);
    return (jsx(StyledTableHeaderRow, Object.assign({ as: "div", ref: scrollerRef }, rest, { scrollbarWidth: scrollbarWidth, rtl: rtl, className: "hidden-scrollbar" })));
});
TableHeaderRow.displayName = 'TableHeaderRow';

export { TableHeaderRow as default };
//# sourceMappingURL=TableHeaderRow.js.map
